const getBasemaps = [
  {
    name: "Google.Roads",
    attribution: "© Google",
    url: "https://mt1.google.com/vt/lyrs=m&x={x}&y={y}&z={z}",
  },
  {
    // Free, keyless XYZ tiles with contour lines + hillshade baked in —
    // this replaces the standalone "Show Contours" toggle from before;
    // pick it from the basemap list to see elevation contours instead.
    name: "OpenTopoMap (Contours)",
    attribution:
      'Map data: &copy; OpenStreetMap contributors, SRTM | Map style: &copy; OpenTopoMap (CC-BY-SA)',
    url: "https://{a-c}.tile.opentopomap.org/{z}/{x}/{y}.png",
  },
  {
    name: "Google.Satellite",
    attribution: "© Google",
    url: "https://mt1.google.com/vt/lyrs=s&x={x}&y={y}&z={z}",
  },
  {
    name: "Google.Terrain",
    attribution: "© Google",
    url: "https://mt1.google.com/vt/lyrs=p&x={x}&y={y}&z={z}",
  },
  {
    name: "Esri.WorldTopoMap",
    attribution:
      "Tiles &copy; Esri &mdash; Source: Esri, USGS, NOAA",
    url: "https://server.arcgisonline.com/ArcGIS/rest/services/World_Topo_Map/MapServer/tile/{z}/{y}/{x}",
  },
  {
    name: "OpenStreetMap",
    attribution: "© OpenStreetMap contributors",
    url: "https://{a-c}.tile.openstreetmap.org/{z}/{x}/{y}.png",
  },
  // {
  //   name: "Esri.WorldImagery",
  //   attribution:
  //     "Tiles &copy; Esri &mdash; Source: Esri, i-cubed, USDA, USGS, AEX, GeoEye, Getmapping, Aerogrid, IGN, IGP, UPR-EGP, and the GIS User Community",
  //   url: "https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}",
  // },
];

export default getBasemaps;
